import { Fetch } from 'lib';
import type { BrandSummary } from 'types';

type RequestResponses = {
  brands: BrandSummary[];
};

const getMainPageBrands = async () =>
  await Fetch<RequestResponses>({
    url: 'adminPageBuilder/getMainPageBrands',
  });

export { getMainPageBrands };
